module.exports = __webpack_public_path__ + "c2ef313b974e804dd1098b764cf5bc68.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_3-872.webp
// module id = 597
// module chunks = 0